import useDateLocale from 'hooks/useDateLocale/useDateLocale'
import ReloadBrowserDialog from 'components/ReloadBrowserDialog/ReloadBrowserDialog'
import ForceLogoutDialog from 'components/ForceLogoutDialog/ForceLogoutDialog'
import { AppInstallProvider } from './AppInstallProvider'
import AppLicenseProvider from './AppLicenseProvider'
import { AppAuthProvider } from './AppAuthProvider'
import RouterPortal from 'RouterPortal'
import CheckSubdomainWithTenantProvider from './CheckSubdomainWithTenantProvider'
import ROUTE from 'constant/route'
import { Switch, Route } from 'react-router-dom'
import CustomerFacingDisplayPage from 'pages/CustomerFacingDisplayPage/CustomerFacingDisplayPage'
import { PosHwAgentHubContextProvider } from 'hooks/usePOSHubContext/usePOSHubContext'
import { SnackbarProvider } from 'notistack'
import DocumentPage from 'pages/DocumentPage/DocumentPage'
function POSApplication() {
    return (
        <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            autoHideDuration={3000}
            preventDuplicate
        >
            <PosHwAgentHubContextProvider>
                <AppAuthProvider>
                    <RouterPortal />
                    <ReloadBrowserDialog />
                    <ForceLogoutDialog />
                </AppAuthProvider>
            </PosHwAgentHubContextProvider>
        </SnackbarProvider>
    )
}
function AppRoot() {
    useDateLocale()
    return (
        <AppInstallProvider>
            <CheckSubdomainWithTenantProvider>
                <AppLicenseProvider>
                    <Switch>
                        <Route
                            path={ROUTE.CUSTOMER_FACING_DISPLAY}
                            component={CustomerFacingDisplayPage}
                        />
                        <Route path={ROUTE.DOCUMENT} component={DocumentPage} />

                        <Route path={ROUTE.MAIN} component={POSApplication} />
                    </Switch>
                </AppLicenseProvider>
            </CheckSubdomainWithTenantProvider>
        </AppInstallProvider>
    )
}

export default AppRoot
